import { Campaign, PaginatedResponse } from '../types';
import apiService from './api';

export class CampaignService {
  async getAllCampaigns(
    page: number = 0,
    size: number = 10,
    sort?: string,
    filters?: any
  ): Promise<PaginatedResponse<Campaign>> {
    return apiService.getPaginated<Campaign>('/api/campaigns/admin/all', page, size, sort, filters);
  }

  async getCampaignById(id: string): Promise<Campaign> {
    return apiService.get<Campaign>(`/api/campaigns/${id}`);
  }

  async createCampaign(campaignData: Partial<Campaign>): Promise<Campaign> {
    return apiService.post<Campaign>('/api/campaigns', campaignData);
  }

  async updateCampaign(id: string, campaignData: Partial<Campaign>): Promise<Campaign> {
    return apiService.put<Campaign>(`/api/campaigns/${id}`, campaignData);
  }

  async deleteCampaign(id: string): Promise<void> {
    await apiService.delete(`/api/campaigns/${id}`);
  }

  async getActiveCampaigns(): Promise<Campaign[]> {
    return apiService.get<Campaign[]>('/api/campaigns/active');
  }

  async getCampaignsByBranch(branchId: string): Promise<Campaign[]> {
    return apiService.get<Campaign[]>(`/api/campaigns/branch/${branchId}/active`);
  }
}

export const campaignService = new CampaignService();
export default campaignService;
